import { render, staticRenderFns } from "./PublicationInfoSection.vue?vue&type=template&id=c8744234&"
import script from "./PublicationInfoSection.vue?vue&type=script&lang=js&"
export * from "./PublicationInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports